/**
 * Removes the "support-mobile" item from the menu if it exists.
 * @param inSessionMobileMenu - The array of menu items.
 */
export function removeSupportItem(inSessionMobileMenu: { id: string }[]): void {
  const SUPPORT_ITEM_INDEX = inSessionMobileMenu.findIndex((item) => {
    return item.id.toLowerCase() === 'support-mobile'
  })

  if (SUPPORT_ITEM_INDEX !== -1) {
    inSessionMobileMenu.splice(SUPPORT_ITEM_INDEX, 1)
  }
}

/**
 * Removes the "credentials-mobile" item from the menu if it exists.
 * @param inSessionMobileMenu - The array of menu items.
 */
export function removeCredentialsItem(inSessionMobileMenu: { id: string }[]): void {
  const CREDENTIALS_ITEM_INDEX = inSessionMobileMenu.findIndex((item) => {
    return item.id.toLowerCase() === 'credentials-mobile'
  })

  if (CREDENTIALS_ITEM_INDEX !== -1) {
    inSessionMobileMenu.splice(CREDENTIALS_ITEM_INDEX, 1)
  }
}